export default __webpack_public_path__ + "static/media/spark_39.71b30190.png";